import { render, staticRenderFns } from "./Stakeholders.vue?vue&type=template&id=4709b66d&scoped=true&"
import script from "./Stakeholders.vue?vue&type=script&lang=js&"
export * from "./Stakeholders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4709b66d",
  null
  
)

export default component.exports